import { ICompanyServiceDesk } from "@/api/AppApi/services/company/interfaces/ICompany";
import ContactUsSubtitle from "../ContactUsSubtitle";
import CustomersServiceBox from "./CustomersServiceBox";
import OptionsCarousel from "@/app/components/common-filter-builder/common-filters-components/OptionsCarousel";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  service_desk: ICompanyServiceDesk[];
}
const CustomersServiceCarousel: React.FC<Props> = ({ service_desk }) => {
  const t = useTranslation();
  return (
    <div>
      <ContactUsSubtitle text={t.customers_service} />
      <OptionsCarousel width={190.5} spacing={16}>
        {service_desk?.map((sd, index) => (
          <CustomersServiceBox key={index} serviceDesk={sd} />
        ))}
      </OptionsCarousel>
    </div>
  );
};

export default CustomersServiceCarousel;
